<template>
  <div class="card" v-bind:class="cardColor">
    <h2 class="card-h2" v-if="title" v-bind:class="[{'s-icon': cardIcon}]">
      <span><i v-if="cardIcon" class="material-icons card-icon">{{cardIcon}}</i> {{title}}</span>
    </h2>
    <div class="card-content">
      <BarChart :bar-color="barColor"
                :chart-data="chartData" 
                :chart-height="chartHeight"
                :chart-type="chartType"
                :label-prefix="labelPrefix"
                :legend-color="legendColor"
                :legend-link="legendLink"
                :show-legend="showLegend"
                :stacked="stacked"
                :x-max-axes-rotation="xMaxAxesRotation"
                :x-min-axes-rotation="xMinAxesRotation"></BarChart>
    </div>
    <button v-if="hasResults" v-on:click="loadFullList" class="btn full-list-button">Full list</button>
  </div>
</template>

<script>
import BarChart from '@/components/barCharts/BarChart'

export default {
  name: 'ranks',

  props: {
    'cardColor': {
      type: String,
      required: false
    },
    'cardIcon': {
      type: String,
      required: false
    },
    'fullListToggleDispatch': {
      type: String,
      required: false
    },
    'fullListOptionsDispatch': {
      type: String,
      required: false
    },
    'fullListOptions': {
      type: Object,
      required: false
    },
    'getter': {
      type: String,
      required: true
    },
    'title': {
      type: String,
      required: false
    },

    // == Bar Chart options/props in BarChart.vue

    'barColor': {
      type: String,
      required: false
    },
    'chartHeight': {
      type: Number,
      required: false,
      default: 180
    },
    'chartType': {
      type: String,
      required: false,
      default: 'horizontalBar'
    },
    'labelPrefix': {
      type: String,
      required: false
    },
    'legendColor': {
      type: String,
      required: false
    },
    'legendLink': {
      type: String,
      required: false
    },
    'showLegend': {
      type: Boolean,
      required: false,
      default: true
    },
    'stacked': {
      type: Boolean,
      required: false,
      default: false
    },
    'xMaxAxesRotation': {
      type: Number,
      required: false,
      default: 90
    },
    'xMinAxesRotation': {
      type: Number,
      required: false,
      default: 0
    }
  },

  components: {
    'BarChart': BarChart
  },

  computed: {
    chartData () {
      return this.$store.getters[this.getter]
    },

    hasResults () {
      return (this.chartData[0] === -1) ? 0 : 1
    }
  },

  methods: {
    loadFullList () {
      this.$store.dispatch(this.fullListToggleDispatch)
      this.$store.dispatch(this.fullListOptionsDispatch, this.fullListOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Ranks.vue?a66dbc82